module.exports = __webpack_public_path__ + "f5fbb27a98f3429aff88885e4e9722fa.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-32.png
// module id = 120
// module chunks = 0